import { useDispatch } from "react-redux";
import { updateUserSlice } from "../store/slices/userSlice";
import { updateUserData } from "../store/slices/updateUserData";
import { updateNotes } from "../store/slices/notesSlice";
import { updateAppointments } from "../store/slices/appointmentsSlice";
import { qalort_token, tokenOptions } from "../components/menu/constant";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cookies, setCookie, removeCookie] = useCookies([qalort_token]);

  const logoutHandler = () => {
    dispatch(updateUserSlice(null));
    dispatch(updateUserData(null));
    dispatch(updateNotes([]));
    dispatch(updateAppointments([]));
    localStorage.removeItem("qalort_token");
    removeCookie(qalort_token, tokenOptions);
    navigate("/login");
  };

  return logoutHandler;
};
